@let currentDraft = draft();
@let currentErrors = errors();

<section
  class="wishlist-create-basic-info-form"
  aria-label="Podstawowe informacje"
>
  <ui-input
    label="Nazwa wishlisty"
    name="wishlistTitle"
    placeholder="np. Urodziny Zosi"
    [value]="currentDraft.title"
    [required]="true"
    [errorText]="currentErrors.title"
    helperText="Krótka i czytelna nazwa pomoże szybko odnaleźć listę."
    (valueChange)="handleTitleChange($event)"
  />

  <ui-textarea
    label="Krótki opis"
    name="wishlistDescription"
    placeholder="np. Pomysły na prezenty na 7. urodziny"
    [value]="currentDraft.description"
    [errorText]="currentErrors.description"
    [rows]="3"
    (valueChange)="handleDescriptionChange($event)"
  />

  <div class="wishlist-create-basic-info-form__group">
    <span class="wishlist-create-basic-info-form__label"
      >Okazja opcjonalnie</span
    >
    <div class="wishlist-create-basic-info-form__chips" aria-label="Typ okazji">
      @for (occasion of occasionOptions(); track occasion.id) {
        <ui-chip
          [active]="currentDraft.occasion === occasion.id"
          [tone]="currentDraft.occasion === occasion.id ? 'primary' : 'neutral'"
          (selected)="handleOccasionSelected(occasion.id)"
        >
          {{ occasion.label }}
        </ui-chip>
      }
    </div>
  </div>

  @if (currentDraft.occasion === 'custom') {
    <ui-input
      label="Własna okazja"
      name="customOccasionLabel"
      placeholder="np. Pierwszy turniej"
      [value]="currentDraft.customOccasionLabel"
      [errorText]="currentErrors.customOccasionLabel"
      (valueChange)="handleCustomOccasionLabelChange($event)"
    />
  }

  <ui-input
    label="Data okazji opcjonalnie"
    name="occasionDate"
    type="date"
    [value]="currentDraft.occasionDate"
    (valueChange)="handleOccasionDateChange($event)"
  />
</section>
